import Vue from "vue";
import Toast from "vue-toastification";
// Базовые стили библиотеки; внешний вид переопределяется в styles/theme.css
import "vue-toastification/dist/index.css";

const options = {
  transition: "Vue-Toastification__fade",
  // Больше четырёх сообщений оператор всё равно не прочитает, а стопка
  // перекрывает рабочую область.
  maxToasts: 4,
  newestOnTop: true,
  position: "top-center",
  timeout: 6000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: true,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  // Одна и та же ошибка, пришедшая из нескольких запросов подряд, должна
  // показываться один раз — стопка одинаковых сообщений ничего не добавляет.
  filterBeforeCreate: (toast, toasts) => {
    const same = toasts.find(
      t => t.type === toast.type && t.content === toast.content
    )

    return same ? false : toast
  }
};

Vue.use(Toast, options);
